import SingleChoiceQue from "./SingleChoiceQue";
import MultiChoiceQue from "./MultiChoiceQue";
import TextQue from "./TextQue";
import MoodSelector from "../MoodSelector";

const DisplayQuestionCard = ({
  queId,
  queType,
  queText,
  answersSet,
  onQueRemove,
}) => {
  return (
    <div className="relative mt-4 bg-white rounded-2xl border border-slate-200 shadow-sm p-6">
      {queType === "mood" ? (
        <MoodSelector disabled />
      ) : queType === "single" ? (
        <SingleChoiceQue queTitle={queText} answers={answersSet} />
      ) : queType === "multi" ? (
        <MultiChoiceQue queTitle={queText} answers={answersSet} />
      ) : (
        <TextQue queTitle={queText} />
      )}
    </div>
  );
};

export default DisplayQuestionCard;
